/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { isArray, join, map, find } from 'lodash';
import { FilterBaseType } from '../filter-types';
import { multiLabelFields } from '../../../utils/shared';
import './styles/ActiveFilter.css';

const ActiveFilter = ({
  id,
  label,
  onClear,
  value,
  booleanSeparator,
  tooltip
}) => {
  const filterButton = isTooltipForValue(tooltip, value) ? (
    <ActiveFilterButtonWithTooltip
      {...{ id, label, onClear, value, booleanSeparator, tooltip }}
    />
  ) : (
    <ActiveFilterButton {...{ label, onClear, value, booleanSeparator }} />
  );
  return filterButton;
};

const isTooltipForValue = (tooltip, { value }) => {
  let showTooltip = false;
  if (tooltip && tooltip.showOnValues) {
    const options = tooltip.showOnValues;
    showTooltip = !!find(options, option => option === value);
  }
  return showTooltip;
};

const formatFilterBubble = (value, booleanSeparator) => {
  if (isArray(value)) {
    const excluded = [];
    const included = [];

    const base = join(map(value, 'label'), booleanSeparator).split(',');

    base.map(e => {
      const g = e.replace(' Excludes:', 'Excludes:');
      if (g.startsWith(' Excludes:') || g.startsWith('Excludes:')) {
        const f = g.replaceAll(' Excludes:', ' ').replaceAll('Excludes:', ' ');
        const i = ` ${f}`;
        excluded.push(i);
      } else if (e.startsWith(' -') || e.startsWith('-')) {
        const h = g.replaceAll(' -', ' ').replace('-', ' ');
        excluded.push(h);
      } else {
        included.push(e);
      }
      return null;
    });

    const exString = join(excluded);
    const inString = join(included);

    const haveExcluded = `<span style="text-decoration: underline">excludes</span> ${exString}`;
    const haveIncluded = `<span style="text-decoration: underline">includes</span> ${inString}`;

    let finalBubble;

    if (inString.length > 0 && exString.length > 0) {
      finalBubble = `${haveIncluded} and ${haveExcluded}`;
    } else if (inString.length > 0 && exString.length <= 0) {
      finalBubble = `${haveIncluded}`;
    } else {
      finalBubble = `${haveExcluded}`;
    }
    return { __html: finalBubble };
  }
  return { __html: value.label };
};

const addColonToNonMulti = label => {
  const colon = multiLabelFields.includes(label) ? ' ' : ': ';
  return colon;
};

const ActiveFilterContent = ({ label, onClear, value, booleanSeparator }) => {
  let panelValue;

  if (label === 'Panel' && isArray(value)) {
    switch (value[0].label) {
      case 'No':
        panelValue = 'Total';
        break;
      case 'Yes':
        panelValue = 'Balanced';
        break;
      default:
        panelValue = 'Balanced';
        break;
    }
  } else {
    panelValue = value.label;
  }

  return (
    <>
      {label === 'Panel' ? (
        <span className="tvt-filters__active-filter-value">
          {`${label}: `}
          {panelValue}
        </span>
      ) : (
        <span className="tvt-filters__active-filter-value">
          {label}
          {addColonToNonMulti(label)}
          <span
            dangerouslySetInnerHTML={formatFilterBubble(
              value,
              booleanSeparator
            )}
          />
        </span>
      )}
      <Button
        bsSize="large"
        bsStyle="link"
        className="tvt-filters__active-filter-clear"
        onClick={onClear}
      >
        &times;
      </Button>
    </>
  );
};

const ActiveFilterButton = props => (
  <li className="tvt-filters__active-filter">
    <ActiveFilterContent {...props} />
  </li>
);

// OverlayTrigger is not working with custom components, workaround is to wrap component with html
const ActiveFilterButtonWithTooltip = props => {
  const { tooltip, id, ...restProps } = props;
  return (
    <OverlayTrigger
      placement={tooltip.placement}
      overlay={
        <Tooltip id="tvt-filters-active-filter-tooltip">{tooltip.text}</Tooltip>
      }
    >
      <li className="tvt-filters__active-filter">
        <ActiveFilterContent {...restProps} />
      </li>
    </OverlayTrigger>
  );
};

ActiveFilter.propTypes = {
  label: PropTypes.string.isRequired,
  onClear: PropTypes.func.isRequired,
  value: FilterBaseType.value.isRequired, // eslint-disable-line react/no-typos
  booleanSeparator: PropTypes.string.isRequired,
  tooltip: PropTypes.shape({
    placement: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  })
};

export default ActiveFilter;
